module.exports = __webpack_public_path__ + "static/PCBanner-OrangeMobile-d729102ad32dcb97f749f4d7ffeaaeb6.png";